<template>
  <div>
    <div class="text-left mb-2 mt-1">
      <el-radio-group v-model="field.is_global_variable" @change="setData">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="form-group">
            <div v-if="errors" class="error-message">
              {{ errorMessage }}
            </div>

            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Options
              </label>
              <div class="flex items-center !gap-1">
                <el-select
                  v-model="field.options"
                  placeholder="Enter options"
                  :clearable="true"
                  :allow-create="true"
                  :default-first-option="true"
                  :filterable="true"
                  multiple
                  collapse-tags
                  @change="validateOptions"
                  :no-data-text="''"
                  class="flex-1 !mt-1"
                >
                  <el-option
                    v-for="(opt, index) of field.options"
                    :key="index"
                    :label="opt"
                    :value="opt"
                  ></el-option>
                </el-select>
                <div
                  class="!p-1.5 !px-2 rounded-md bg-[#E0E0E0] w-fit cursor-pointer"
                  @click="openOptions"
                >
                  <img src="@/assets/img/icons/new/edit-black-icon.svg" alt="" class="!size-4" />
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="!mt-1">
            <el-checkbox v-model="field.add_global">Add to Global Variable</el-checkbox>
          </div>
          <div class="!mt-1">
            <el-checkbox v-model="field.allow_to_create">Allow User To Create</el-checkbox>
          </div>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <field-attributes :field="field" />
        </el-col>

        <el-col :span="12">
          <div class="grid md:!grid-cols-2 !gap-2">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Min Selection
              </label>
              <el-input-number v-model="field.min_selection" class="!w-full"></el-input-number>
            </el-form-item>
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Max Selection
              </label>
              <el-input-number v-model="field.max_selection" class="!w-full"></el-input-number>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <is-field-required :field="field" />
        </el-col>
        <el-col :span="24">
          <div class="icon-dropdown-selection flex items-center !gap-3">
            <span
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Icon
            </span>
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon !gap-2">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="20">
        <el-col :span="24">
          <div class="form-group">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Global Variable
              </label>
              <el-select
                v-model="field.global_variable_id"
                @change="setGlobalVariable"
                class="!w-full"
              >
                <el-option
                  v-for="(globalVariable, index) of allGlobalVariables"
                  :key="index"
                  filterable
                  :label="globalVariable.label"
                  :value="globalVariable._id"
                >
                  <span style="float: left">{{ globalVariable.label }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" />
    </el-form>
    <dialog-component
      id="settingsDialog"
      :visible="optionsDialogVisible"
      :title="'Edit options'"
      :destroy-on-close="true"
      :containerWidth="'35%'"
      @before-close="optionsDialogVisible = false"
      center
    >
      <el-table
        border
        :data="dialogOptions"
        @cell-mouse-enter="editoptionsData"
        @cell-mouse-leave="resetoptionsData"
      >
        <el-table-column label="Options">
          <template slot-scope="scope">
            <div v-if="currentActiveRowIndex == scope.$index">
              <el-input size="mini" v-model="dialogOptions[currentActiveRowIndex]"></el-input>
            </div>
            <div v-else>
              <p style="font-size: 14px" slot="reference">
                {{ scope.row }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="background-color: var(--brand-500); float: right; color: #ffffff"
          class="type-2"
          @click="saveData"
        >
          Save
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      id="settingsDialog"
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  import { mapGetters } from 'vuex';

  export default {
    name: 'templates-formComponents-MultiSelect',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
      FieldAttributes: () => import('./FieldAttributes'),
    },
    props: ['field', 'isView'],
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    data() {
      return {
        validations: [],
        rowsOptions: [
          {
            title: 'Folder 1',
            _id: '1',
          },
          {
            title: 'Folder 2',
            _id: '2',
          },
          {
            title: 'Folder 3',
            _id: '3',
          },
        ],
        errors: false,
        errorMessage: '',
        initialValidation: false,
        optionsDialogVisible: false,
        currentActiveRowIndex: -1,
        dialogOptions: [],
        iconPickerdialogVisible: false,
        getAllGlobalVariables: null,
        templateIconPath: 'dashboard',
      };
    },
    mounted() {
      this.fetchGlobalVaribales();
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
      this.initialValidation = true;
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      openOptions() {
        if (this.isView) {
          return;
        }
        this.optionsDialogVisible = true;
      },
      setData() {
        if (!this.field.is_global_variable) {
          this.field.global_variable_id = null;
        }
      },
      async fetchGlobalVaribales() {
        let params = {
          get_all: true,
          input_types: ['MULTI_SELECT'],
        };
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },
      setGlobalVariable() {
        let globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
        this.field.options = globalVariable.options;
        this.field.min_selection = globalVariable.min_selection;
        this.field.max_selection = globalVariable.max_selection;
      },
      validateOptions() {
        const options = this.field.options.map((opt) => opt.trim());
        const normalizedOptions = options.map((opt) => opt.toLowerCase());

        // Check if options array is empty
        if (options.length === 0 && this.initialValidation) {
          this.errors = true;
          this.errorMessage = ' ';
          return;
        }

        // Check if any option consists only of spaces
        const hasInvalidOptions = options.some((opt) => opt.trim() === '');
        if (hasInvalidOptions) {
          this.errors = true;
          this.errorMessage = 'An option should not be only of spaces,so please remove it.';
          return;
        }

        const uniqueNormalizedOptions = [...new Set(normalizedOptions)];
        if (uniqueNormalizedOptions.length !== normalizedOptions.length) {
          this.errors = true;
          this.errorMessage = 'Duplicate options (case-insensitive) were removed.';
        }
        // Filter out duplicate options and keep the first occurrence
        const uniqueOptions = options.filter((opt, index) => {
          return normalizedOptions.indexOf(opt.toLowerCase()) === index;
        });
        this.field.options = uniqueOptions;

        this.errors = false;
        this.errorMessage = '';
      },
      editoptionsData(row) {
        this.currentActiveRowIndex = this.field.options.indexOf(row);
      },
      resetoptionsData() {
        // Normalize options to lowercase and filter out duplicates
        const normalizedOptions = this.dialogOptions.map((option) => option.trim().toLowerCase());
        const uniqueOptions = this.dialogOptions.filter((option, index) => {
          return normalizedOptions.indexOf(option.trim().toLowerCase()) === index;
        });
        this.dialogOptions = uniqueOptions;
        this.field.options = uniqueOptions.slice();
        this.currentActiveRowIndex = -1;
      },
      saveData() {
        this.optionsDialogVisible = false;
      },
    },
    watch: {
      optionsDialogVisible(newVal) {
        if (newVal) {
          this.dialogOptions = this.field.options.slice();
        }
      },
    },
  };
</script>

<style lang="scss">
  .error-message {
    color: red;
  }

  .tableScroll {
    height: 50vh;
    overflow-y: scroll;
    overflow-x: scroll;
    border-top: 1px ridge;
    border-left: 1px ridge;
    border-bottom: 1px ridge;
    margin-right: 5px;
    width: 100%;
  }

  .tableScroll::-webkit-scrollbar {
    width: 0.5em;
  }

  .tableScroll::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }

  .el-input-number__decrease,
  .el-input-number__increase {
    width: 30px;
    height: 30px;
    top: calc(50% - 15px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
